function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "a"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "b"
}, /*#__PURE__*/React.createElement("g", {
  id: "c"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M77.78,232.14c11.26-13,55.63-79.86,70.63-127.47,3.16-8.32,4.9-17.33,4.9-26.76C153.31,36.26,119.55,2.5,77.91,2.5S2.5,36.26,2.5,77.91c0,5.58,.62,11.01,1.78,16.25h-.02c.12,.49,.24,1,.37,1.51,.15,.61,.3,1.21,.46,1.81,12.41,47.77,60.86,120.99,72.7,134.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M77.78,232.14l1.89,1.64c1.48-1.71,3.43-4.22,5.78-7.42,8.2-11.18,21.19-30.87,33.81-53.03,12.62-22.17,24.87-46.78,31.53-67.91l-2.38-.75,2.34,.89c3.26-8.59,5.07-17.91,5.07-27.65C155.81,34.88,120.93,0,77.91,0,34.88,0,0,34.88,0,77.91c0,5.77,.65,11.38,1.83,16.79l2.44-.54,1.46-2.03h-.02l-5.4-3.91,1.5,6.48c.12,.53,.25,1.05,.37,1.55h0c.15,.61,.3,1.24,.47,1.87v-.02c3.16,12.17,8.57,25.82,15.08,39.71,9.77,20.83,22.04,42.18,32.98,59.64,5.47,8.73,10.62,16.48,14.96,22.71,4.35,6.23,7.87,10.92,10.2,13.62l1.89,2.18,1.89-2.18-1.89-1.64,1.89-1.64c-1.4-1.61-3.43-4.22-5.88-7.59-8.61-11.81-22.54-33.04-35.62-56.46-6.54-11.71-12.88-23.98-18.25-35.89-5.36-11.91-9.76-23.47-12.42-33.72v-.02c-.16-.57-.3-1.15-.45-1.75h0c-.12-.52-.25-1.02-.36-1.5l-2.44,.56-1.46,2.03h.02l5.31,3.85-1.41-6.4c-1.11-5.07-1.72-10.32-1.72-15.71,0-20.14,8.16-38.35,21.35-51.55C39.56,13.16,57.77,5,77.91,5c20.14,0,38.35,8.16,51.55,21.35,13.2,13.2,21.35,31.41,21.35,51.55,0,9.12-1.69,17.83-4.74,25.87l-.02,.06-.03,.08c-7.38,23.47-22.16,52-36.48,76.19-7.16,12.1-14.21,23.13-20.16,31.92-2.97,4.4-5.67,8.24-7.97,11.37-2.29,3.13-4.2,5.56-5.53,7.1l1.89,1.64,1.89-1.64-1.89,1.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M94.45,128.75c0-9.2-7.46-16.66-16.66-16.66s-16.66,7.46-16.66,16.66,7.46,16.66,16.66,16.66,16.66-7.46,16.66-16.66Zm-16.08,9.62c0,.79-.64,1.42-1.42,1.42-5.69,0-10.32-4.63-10.32-10.32,0-.79,.64-1.42,1.42-1.42s1.42,.64,1.42,1.42c0,4.12,3.35,7.48,7.48,7.48,.79,0,1.42,.64,1.42,1.42Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "d",
  x: 71.18,
  y: 65.15,
  width: 13.44,
  height: 54.55
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M84.63,64.83c0,3.66-3.01,6.63-6.73,6.63s-6.73-2.97-6.73-6.63,3.01-6.63,6.73-6.63,6.73,2.97,6.73,6.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M88.73,110.87h1s.04-71.96,.04-72.24c0-3.16-1.35-6.03-3.5-8.08-2.16-2.06-5.13-3.32-8.4-3.32-3.27,0-6.24,1.27-8.4,3.32-2.16,2.05-3.5,4.92-3.5,8.08V111.01h1l-.5-.86c-6.54,3.79-10.94,10.74-10.94,18.69,0,6.02,2.52,11.47,6.59,15.4,4.06,3.93,9.68,6.36,15.87,6.36,6.19,0,11.8-2.43,15.87-6.36,4.06-3.93,6.59-9.39,6.59-15.4,0-8.06-4.52-15.08-11.21-18.84l-.49,.87h0l-.49,.87c6.1,3.43,10.19,9.8,10.19,17.09,0,5.45-2.28,10.38-5.98,13.96-3.7,3.58-8.81,5.8-14.47,5.8-5.66,0-10.77-2.22-14.47-5.8-3.7-3.58-5.98-8.51-5.98-13.96,0-7.19,3.98-13.49,9.94-16.96l.5-.29V38.63c0-2.59,1.1-4.92,2.89-6.63,1.79-1.71,4.27-2.77,7.02-2.77,2.75,0,5.23,1.06,7.02,2.77,1.79,1.71,2.88,4.05,2.88,6.63,0,.13-.01,18.2-.02,36.22-.01,18.03-.02,36.02-.02,36.02v.58l.51,.29,.49-.87Z"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "d",
  points: "102.69 69.17 88.36 69.17 88.36 72.17 102.69 72.17"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "d",
  points: "97.71 39.17 88.36 39.17 88.36 42.17 97.71 42.17"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "d",
  points: "97.71 59.17 88.36 59.17 88.36 62.17 97.71 62.17"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "d",
  points: "102.69 49.17 88.36 49.17 88.36 52.17 102.69 52.17"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "d",
  points: "97.71 99.17 88.36 99.17 88.36 102.17 97.71 102.17"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "d",
  points: "102.69 89.17 88.36 89.17 88.36 92.17 102.69 92.17"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "d",
  points: "97.71 79.17 88.36 79.17 88.36 82.17 97.71 82.17"
}))));

var SvgThermalHotspot = function SvgThermalHotspot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 155.81 235.96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThermalHotspot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thermal-hotspot.8497bc32.svg";
export { ForwardRef as ReactComponent };